import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateEventDocument } from './create.generated';

export const useCreateEvent = (options: ApiOptions<typeof CreateEventDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CreateEventDocument, {
    ...useNotifications(CreateEventDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.events.create_success'),
    }),
    ...options,
  });
};
